import React from 'react'
import ProgressUI from '../../widgets/output/ProgressUI'
import PageTitleUI from '../../widgets/output/PageTitleUI'
import EmptyListUI from '../../widgets/output/EmptyListUI'
import PrivatePageSF from '../../templates/PrivatePageSF.js'
import LabelAndValueUI from '../../widgets/layout/LabelAndValueUI'
import GenericErrorUI from '../../components/common/GenericErrorUI'
import InvoiceListUI from '../../components/finapp/invoice/InvoiceListUI'
import SpinnerComponentUI from '../../components/common/SpinnerComponentUI'
import InvoiceCreateModalSF from '../../components/finapp/invoice/InvoiceCreateModalSF'
import './InvoiceListPage.css'

const InvoiceListPageUI = ({ context, messageList, errorList, invoiceList, filteredInvoiceList,
  searchFilter, onRefreshClick, onSearchFilterChange,
  onCreateInvoiceClick, createInvoiceMode, onCancelCreateInvoice, onCreateInvoiceComplete
}) =>
  <PrivatePageSF context={context} className='pg_ord_invs'
    messageList={messageList} headerMessageKey='c_invoices'
    centered={!invoiceList && !errorList}
  >
    {
      !invoiceList && !errorList &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      invoiceList &&
      <PageTitleUI context={context} messageList={messageList} titleMessageKey='c_invoices' />
    }
    {
      invoiceList && invoiceList.length === 0 &&
      <EmptyListUI
        context={context}
        messageList={messageList}
        createEnabled={context.permissions && context.permissions.includes('acc_manage')}
        onCreateClick={onCreateInvoiceClick}
        createLinkKey='c_create_invoice'
        createDisabledMessageKey='c_no_invoice_msg'
      />
    }
    {
      invoiceList && filteredInvoiceList && invoiceList.length !== 0 &&
      <InvoiceListUI
        context={context}
        invoiceList={filteredInvoiceList}
        messageList={messageList}
        searchFilter={searchFilter}
        // events
        onCreateClick={onCreateInvoiceClick}
        onRefreshClick={onRefreshClick}
        onSearchFilterChange={onSearchFilterChange}
      />
    }
    <InvoiceCreateModalSF context={context} createMode={createInvoiceMode}
      onCancelClick={onCancelCreateInvoice} onCreateComplete={onCreateInvoiceComplete}
    />
  </PrivatePageSF>

export default InvoiceListPageUI
